import { render, staticRenderFns } from "./ProductFiltersMenu.vue?vue&type=template&id=5f8507c0&lang=pug&"
import script from "./ProductFiltersMenu.vue?vue&type=script&lang=js&"
export * from "./ProductFiltersMenu.vue?vue&type=script&lang=js&"
import style0 from "./ProductFiltersMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports